import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { fetchResourceMetricsPerDay } from 'js/actions';
import moment from 'moment';

export function useResourceUsageMetrics(id: number | string, type: string) {
  const dispatch = useDispatch();
  const metrics = useSelector((state: any) => state?.metrics);

  const fetch = useCallback(
    (dates) => {
      const formattedDates = {
        start: moment(dates.start).format('YYYY-MM-DD'),
        end: moment(dates.end).format('YYYY-MM-DD'),
      };
      dispatch(fetchResourceMetricsPerDay(id, type, formattedDates));
    },
    [id, type],
  );

  return useMemo(() => {
    const metricsType = metrics?.[type];
    const metricsTypeById = metricsType?.[id] || {};

    return {
      data: metricsTypeById?.byDate,
      usage: metricsTypeById?.agg?.metrics,
      fetch,
    };
  }, [type, id, metrics]);
}
